import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  data: [],
  instance: null,
  loading: false,
  options: [],
  errors: null,
  next: null,
  count: 0,
}

export const constituentsSlice = createSlice({
  initialState,
  name: 'constituents',
  reducers: {
    loadConstituents(state) {
      state.loading = true
      state.data = []
      state.next = null
    },
    storeConstituents(state, action) {
      const { count, next, results } = action.payload
      if (results) state.data = [...state.data, ...results]
      if (next) state.next = next
      if (count) state.count = count
      state.loading = false
    },

    loadConstituentInstance(state) {
      state.loading = true
      state.instance = {}
      state.next = null
    },
    storeConstituentInstance(state, action) {
      state.instance = action.payload
      state.loading = false
      state.errors = null
    },

    startExportConstituents(state) {
      state.exporting = true
    },
    completeExportConstituents(state) {
      delete state.exporting
    },

    loadConstituentOptions(state) {
      state.options_loading = true
    },
    paginateConstituentOptions() {},
    storeConstituentOptions(state, action) {
      const { results, next } = action.payload

      state.options = [...state.options, ...results]
      state.options_next = next
      state.options_loading = false
    },

    loadConstituentTags(state) {
      state.tag_options = []
      state.tags_loading = true
      delete state.tags_count
      delete state.tags_next
    },
    createConstituentTag() {},
    updateConstituentTag() {},
    deleteConstituentTag() {},
    mergeConstituentTags() {},
    paginateConstituentTags() {},
    setConstituentTags(state, action) {
      const { tags, count } = action.payload
      if (tags) state.tag_options = tags
      if (count) state.tags_count = count
    },
    storeConstituentTags(state, action) {
      const { results, next, count } = action.payload
      state.tag_options = [...(state.tag_options || []), ...results]
      state.tags_next = next
      state.tags_count = count
      state.tags_loading = false
    },
    clearConstituentTags(state) {
      state.tag_options = []
      delete state.tags_next
      delete state.tags_count
    },
    loadConstituentsByTag() {},
    addConstituentToTag() {},
    removeConstituentFromTag() {},

    mergeConstituents() {},
    selectConstituent(state, action) {
      const index = action.payload
      if (!state.selected) {
        state.selected = [index]
      } else if (!state.selected.includes(index)) {
        state.selected = [...state.selected, index]
      }
    },
    deselectConstituent(state, action) {
      const index = action.payload
      if (state.selected?.length > 0) {
        state.selected = state.selected.filter(c => c !== index)
      }
    },
    clearConstituents(state) {
      state.data = []
      state.next = null
      state.count = 0
      delete state.selected
    },
    clearConstituentInstance(state) {
      state.instance = null
    },
    clearConstituentOptions(state) {
      state.options = []
      delete state.options_next
    },

    createConstituent() {},
    createIndividualConstituent() {},
    updateConstituent() {},
    deleteConstituent() {},

    paginate(state) {
      state.loading = true
    },
    cancelLoading(state) {
      state.loading = false
    },
    setErrors(state, action) {
      state.loading = false
      state.errors = action.payload
    },
  },
})

export default constituentsSlice.reducer

export const {
  loadConstituents,
  storeConstituents,

  loadConstituentInstance,
  storeConstituentInstance,

  startExportConstituents,
  completeExportConstituents,

  loadConstituentOptions,
  paginateConstituentOptions,
  storeConstituentOptions,

  // Constituent Tag actions,
  loadConstituentTags,
  paginateConstituentTags,
  setConstituentTags,
  createConstituentTag,
  updateConstituentTag,
  deleteConstituentTag,
  mergeConstituentTags,
  storeConstituentTags,
  clearConstituentTags,

  loadConstituentsByTag,
  addConstituentToTag,
  removeConstituentFromTag,

  clearConstituents,
  clearConstituentInstance,
  clearConstituentOptions,

  createConstituent,
  createIndividualConstituent,
  updateConstituent,
  deleteConstituent,

  mergeConstituents,
  selectConstituent,
  deselectConstituent,

  paginate,
  cancelLoading,
  setErrors,
} = constituentsSlice.actions
